'use strict';
import React from 'react';
import {buildFormHOC} from '../../../components/forms/Form';
import {INPUT_TYPES} from '../../../components/forms/FormField';
import {canEditChildProp} from '../../domain/utils';
import {FileRequirementFormView} from './FileRequirementFormView';


export const FileRequirementFormComponent = buildFormHOC(FileRequirementFormView, {
  fields: [{
    property: 'name',
    type: INPUT_TYPES.text,
    constraints: {nullable: false},
    canEdit: canEditChildProp,
    useError: true,
  }, {
    property: 'minimumFileCount',
    type: INPUT_TYPES.number,
    constraints: {nullable: false, min: 0},
    canEdit: true,
    useError: true,
  }, {
    property: 'maximumFileCount',
    type: INPUT_TYPES.number,
    constraints: {nullable: false, min: 1},
    canEdit: true,
    useError: true,
  }, {
    property: 'countIsEnforced',
    type: INPUT_TYPES.checkbox,
    constraints: {},
    canEdit: true,
    useError: true,
  }, {
    property: 'description',
    type: INPUT_TYPES.text_long,
    constraints: {nullable: true},
    canEdit: true,
    useError: true,
  }],
});



// WEBPACK FOOTER //
// ./src/js/requirements/components/FileRequirementForm/FileRequirementFormComponent.js